

export const ComputeChannelAverages = {
	name: "ComputeChannelAverages",
	description:"Computes the average value for every numeric data channel.",
	parameters: {

	},
	output:{
		count:{
			type:"number"
		},
		labels:{
			type:"string[]"
		},
		values:{
			type:"number[]"
		}
	}
};